import Vue from 'vue';
import Router from 'vue-router';
import store from './store/index';
import CertificatePage from './views/CertificatePage.vue';
// import LandingPage from './views/LandingPage.vue';
import PageNotFound from './views/PageNotFound.vue';
// import Report from './views/Report.vue';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'landing',
    //   component: LandingPage,
    // },
    {
      path: '*',
      name: 'certificate',
      component: CertificatePage,
    },
    // {
    //   path: '/:public_key',
    //   name: 'certificate',
    //   component: CertificatePage,
    // },
  //   {
  //     path: '/report',
  //     name: 'report',
  //     component: Report,
  //   },
    { path: '/page-not-found',
    name: 'page-not-found',
    component: PageNotFound,
  }
  ],
});

router.beforeEach((to: any, from: any, next: any) => {
  if (to.name === 'login' || to.name === 'register'
      || to.name === 'forgot-password' || to.name === 'email-confirmation') {
    store.commit('MUTATE_SHOW_NAVIGATION', false);
  } else {
    store.commit('MUTATE_SHOW_NAVIGATION', true);
  }
  next();
});

export default router;

